import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {catchError, Observable, throwError} from 'rxjs';

interface UpdateTaskStatusRequest {
    taskId: number;
    statusId: number;
}

interface UpdateTaskStatusResponse {
    taskId: number;
    newStatus: string;
}

export interface TaskDetailResponse {
    id: number;
    parentTaskId: number | null;
    title: string;
    createdBy: string;
    assignee: string;
    assigneeId: number;
    startDate: string;
    dueDate: string;
    status: string;
    statusId: number;
    category: string;
    categoryId: number;
    farm: string;
    farmId: number;
    house: string;
    houseId: number;
    partition: string;
    partitionId: number;
    cycle: string;
    cycleId: number;
    attachments: string[];
    subTasks: SubTaskDetail[];
}

export interface SubTaskDetail {
    id: number;
    parentTaskId: number;
    title: string;
    assignee: string;
    assigneeId: number;
    startDate: string;
    dueDate: string;
    status: string;
    statusId: number;
    category: string;
    categoryId: number;
    subTaskAttachment: string;
    description: string | null;
}

// Interface for Update Task Details Request
export interface UpdateTaskDetailsRequest {
    id: number;
    title: string;
    assigneeId: number;
    farmId: number;
    farmHouseId: number;
    partitionId: number;
    cycleId: number;
    startDate: string;
    dueDate: string;
    categoryId: number;
    statusId: number;
    attachment: string | null;
    subTasks: SubTaskUpdateRequest[];
    description: string;
}

export interface SubTaskUpdateRequest {
    id: number;
    title: string;
    assigneeId: number;
    startDate: string;
    dueDate: string;
    statusId: number;
    subTaskAttachment: string | null;
    description: string;
}

export interface UpdateTaskDetailsResponse {
    message: string;
    taskId: number;
}
@Injectable({
    providedIn: 'root'
})
export class TaskService {
    constructor(private httpClient: HttpClient) {}
    private apiUrl = environment.apiUrl;

    createTask(task: any): Observable<any[]> {
        return this.httpClient
            .post<[]>(`${this.apiUrl}/Task/CreateTask`, task)
            .pipe(catchError(this.error));
    }

    getTaskStatus() {
        return this.httpClient
            .get(`${this.apiUrl}/Task/GetTaskStatus`)
            .pipe(catchError(this.error));
    }

    getTaskCategories() {
        return this.httpClient
            .get(`${this.apiUrl}/Task/GetTaskCategories`)
            .pipe(catchError(this.error));
    }

    getTaskList(filter: {
        title?: string;
        assigneeId?: number;
        categoryId?: number;
        statusId?: number;
        farmId?: number;
        houseId?: number;
        partitionId?: number;
        cycleId?: number;
        dueDate?: string;
        parentTaskId: '';
    }) {
        return this.httpClient
            .post(`${this.apiUrl}/Task/GetTaskList`, filter)
            .pipe(catchError(this.error));
    }

    updateTaskStatus(
        payload: UpdateTaskStatusRequest
    ): Observable<UpdateTaskStatusResponse> {
        return this.httpClient
            .post<UpdateTaskStatusResponse>(
                `${this.apiUrl}/Task/UpdateTaskStatusByTaskId`,
                {},
                {
                    params: {
                        taskId: payload.taskId,
                        statusId: payload.statusId
                    }
                }
            )
            .pipe(catchError(this.error));
    }

    getTaskDetailById(taskId: number): Observable<TaskDetailResponse> {
        return this.httpClient
            .get<TaskDetailResponse>(
                `${this.apiUrl}/Task/GetTaskDetailById?id=${taskId}`
            )
            .pipe(catchError(this.error));
    }

    updateTaskDetails(
        taskData: UpdateTaskDetailsRequest
    ): Observable<UpdateTaskDetailsResponse> {
        return this.httpClient
            .post<UpdateTaskDetailsResponse>(
                `${this.apiUrl}/Task/UpdateTaskDetails`,
                taskData
            )
            .pipe(catchError(this.error));
    }

    // Handle Errors
    error(error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = error.error.message;
        } else {
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }
}
